
import { UserContext } from "context";
import { OtpVerify, superAdminLoginApi } from "features";
import { resetError } from "features/auth/authSlice";
import React, { useContext, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import StorageServices from "utils/StorageServices";
import "../../assets/css/onboard.css";
import { getDashbordData, getLocationDetailsApi } from "_services";
import StorageService from "utils/StorageServices/StorageServices";
import { getCitiesData, getMasterData, getStatesData } from "_services";
import toast from "react-hot-toast";
import Loading from "pages/Loading";

const SuperAdminVerify = () => {
  const { setGenrateOtp, setToken, setUserData, setWarningDetails } =
    useContext(UserContext);
  const navigate = useNavigate();
  const inputRefs = useRef([]);
  const [isVerify, setIsVerify] = useState(false);
  const [locationDetails, setLocationDetails] = useState("")
  const { id } = useParams();

  useEffect(() => {
    document.title = `Transport 360 - भारत का अपना ट्रांसपोर्ट ऐप`;
    getLocationDetails()
  }, []);

  const getLocationDetails = async () => {
    try {
      const res = await getLocationDetailsApi()

      setLocationDetails(res)
    } catch (error) {

    }
  }

  useEffect(() => {
    const initialize = async () => {
      try {
        // Clear all old data first
        setToken(null);
        localStorage.clear();
        sessionStorage.clear();
        StorageServices.clear?.();

        setWarningDetails("");
        setUserData(null);

        await masterDataAndCityStateApi();

        if (id) {
          await handleSuperAdminLogin(id);
        } else {
          navigate("/");
        }
      } catch (error) {
        console.error("Error initializing super admin verify:", error);
      }
    };

    initialize();
  }, [id]);



  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);


  const getCitiesByApi = async () => {
    try {
      let data = {
        countryCode: "IN",
        stateCode: ""
      }
      let response = await getCitiesData(data);
      if (response?.responseCode === 200) {
        const optionsCity = response?.data?.map((d) => {
          return {
            ...d,
            label: d?.name,
            cityStateLabel: `${d?.name}, ${d?.stateName}`,
            value: d?.name,
          };
        });
        StorageService.setCities(JSON.stringify(optionsCity))
      } else {
        if (response) {
          toast.error(response?.responseMessage)
        }

      }
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.")
    }
  }

  const getStatesByApi = async () => {
    try {
      let data = {
        countryCode: "IN",
        stateCode: ""
      }
      let response = await getStatesData(data);
      if (response?.responseCode === 200) {
        const optionsState = response?.data?.map((d) => {
          return {
            ...d,
            label: d?.name,
            value: d?.name
          };
        });

        StorageService.setStates(JSON.stringify([...optionsState]))
      } else {
        if (response) {
          toast.error(response?.responseMessage)
        }

      }
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.")
    }
  }

  const getAllMasterData = async () => {

    const postData = {};
    try {
      let response = await getMasterData(postData);
      if (response?.responseCode === 200) {
        StorageService.setLocalItem("master_data", JSON.stringify(response.data))
      } else {
        toast.error(response?.message)
      }
    } catch (error) {
      console.error('Error fetching master data:', error);
      toast.error("An unexpected error occurred. Please try again.")
    } finally {

    }
  }

  const masterDataAndCityStateApi = () => {
    getAllMasterData();
    getCitiesByApi();
    getStatesByApi();
  }

  const handleSuperAdminLogin = async (id) => {
    const payload = {
      company_id: id
    }
    const toastId = "api-toast";
    try {
      setIsVerify(true)
      const res = await superAdminLoginApi(payload);

      if (res?.responseCode === 200) {
        // masterDataAndCityStateApi();
        const details = res?.data
        StorageServices.setToken(details?.token);
        StorageServices.setUseryID(details?._id);
        StorageServices.setUserExist(details?.user_exists);
        if (
          details?.user_detail?.select_company_id !== "1234" &&
          details?.user_detail?.select_company_id &&
          details?.user_detail?.select_company_id !== "undefined"
        ) {
          let isCompanyExist = details?.user_detail?.company_list?.some((el) => el?.company_id?._id === details?.user_detail?.select_company_id)
          let compId = isCompanyExist ? details?.user_detail?.select_company_id : details?.user_detail?.company_list[0]?.company_id?._id;
          getAllDashboardData(compId == "undefined" ? "" : compId || "");
          StorageServices.setCompanyId(compId == "undefined" ? "" : compId || "");
          StorageServices.setCompName(compId == "undefined" ? "" : compId || "");
          StorageServices.setFirmId(details?.user_detail?.select_firm_id ? details?.user_detail?.select_firm_id : "")
        } else {
          StorageServices.setCompanyId(
            details?.user_detail?.company_list[0]?.company_id?._id == "undefined" ? "" : details?.user_detail?.company_list[0]?.company_id?._id
          );
          StorageServices.setCompName(
            details?.user_detail?.company_list[0]?.company_id?._id == "undefined" ? "" : details?.user_detail?.company_list[0]?.company_id?._id
          );
          StorageServices.setFirmId(details?.user_detail?.select_firm_id ? details?.user_detail?.select_firm_id : "")

        }
        //context variables
        setToken(details?.token);
        StorageService.setLocalItem(
          "userDetais",
          JSON.stringify(details)
        );
        StorageService.setLocalItem(
          "userData",
          JSON.stringify(details)
        );
        setUserData(details);
        setGenrateOtp(false);
        setIsVerify(false)
        navigate("/dashboard");
      } else {
        setIsVerify(false)
        // toast.error(res?.payload?.responseMessage, { id: toastId });
        // setOtpError(res?.payload?.responseMessage)
      }
    } catch (error) {
      setIsVerify(false)
      toast.error(error, { id: toastId });
      // setOtpError(error)
    }
  };



  const getAllDashboardData = async (data) => {
    const postData = {
      company_id: data,
      select_company_id: 1,
    };
    try {
      let response = await getDashbordData(postData);
      if (response?.responseCode === 200) {
        StorageService.setLocalItem("userData", JSON.stringify(response.data));
        setUserData(response.data);
      } else {
        throw response?.responseMessage;
      }
    } catch (error) {
      console.error("Error fetching master data:", error);
      // throw error
    } finally {
    }
  };


  return (
    <div className="_midOb_bx" >
      {isVerify && <div colSpan="100%" className="loaderBg" style={{ textAlign: "center", background: "#ffff" }}>
        <Loading />
      </div>}
    </div>
  );
};

export default SuperAdminVerify;


